export default "__VITE_ASSET__CkrWhJ24__"